import { FC } from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import InsertDriveFileIconOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import { Row } from 'further-ui/components/Layout';
import { downloadLinkAsFile } from 'further-ui/utils';

const InsertDriveFileIcon = styled(InsertDriveFileIconOutlined)({
  fontSize: '16px',
});

const DownloadLink = styled(Link)({
  color: blue[500],
  cursor: 'pointer',
  textDecoration: 'underline',
});

type Props = {
  file: {
    name: string;
    previewUrl: string;
  };
};

const DownloadFile: FC<Props> = ({ file }) => {
  const { name, previewUrl } = file;

  const handleDownload = async () => {
    if (!previewUrl || !name) return;
    await downloadLinkAsFile(previewUrl, name);
  };

  return (
    <Row spacing="xs" centered>
      <InsertDriveFileIcon />
      <Typography variant="h6">{name}</Typography>
      <DownloadLink variant="body2" onClick={handleDownload}>
        Download
      </DownloadLink>
    </Row>
  );
};

export default DownloadFile;
